module.exports = {"BTN_LOGIN":"Se connecter","BTN_RECORD":"Enregistrer","BTN_UPDATE":"Enregistrer","BTN_CANCEL":"Annuler","BTN_TODAY":"Aujourd'hui","BTN_SEEMORE":"Voir plus...","BTN_RELOAD":"Recharger","BTN_OK":"OK","BTN_DELETE_CONFIRM":"Confirmer","BTN_SAVE_WITHOUT_VALIDATE":"Enregistrer sans valider","BTN_SAVE_WITHIN_VALIDATE":"Valider","BTN_CREATE_GROUP":"Nouveau groupe","BTN_CLOSE":"Fermer","BTN_SAVE_CREATE_APPARTMENT":"ENREGISTRER ET CRÉER DES APPARTEMENTS","BTN_MAJ":"Mettre à jour","BTN_DISABLE":"Désactiver","BTN_ENABLE":"Activer"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/button/button.fr.json
// module id = eEdP
// module chunks = 0